import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { createHttpLink } from 'apollo-link-http';
import firebase from 'firebase/app';
import store from './store';
import 'firebase/auth';
import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { createApolloClient } from 'vue-cli-plugin-apollo/graphql-client';
import graphqlIntrospectionResult from './graphqlTypes-generated';

/**
 * Configuration of the apollo-vue client.
 */

// Install the vue plugin
Vue.use(VueApollo);

// Http endpoint for apollo link
const httpEndpoint =
  process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:4000/graphql';

const defaultOptions = {
  httpEndpoint,
  // wsEndpoint: process.env.VUE_APP_GRAPHQL_WS || 'ws://localhost:4000/graphql',
  persisting: false,
  websocketsOnly: false,
  ssr: false,
};

// Create the Apollo provider.
export function createProvider() {
  const graphqlFragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData: graphqlIntrospectionResult,
  });
  const cache = new InMemoryCache({
    fragmentMatcher: graphqlFragmentMatcher,
  });

  const httpLink = createHttpLink({
    uri: httpEndpoint,
  });

  const authLink = setContext(async (_, { headers }) => {
    // Use your async token function here:
    const currentUser = firebase.auth().currentUser;
    let token: string | undefined;

    if (currentUser != null) {
      token = 'Bearer ' + (await currentUser.getIdToken());
    }

    const viewAs = store.getters.viewAs;

    // Return the headers to the context so httpLink can read them.
    return {
      headers: {
        ...headers,
        authorization: token ? token : '',
        ...(viewAs != null ? { 'x-view-as': viewAs.id } : {}),
      },
    };
  });

  const loggerLink = new ApolloLink((operation, forward) => {
    const queryComponent = encodeURIComponent(
      operation.query.loc! && operation.query.loc!.source!.body!
    );

    const tabsComponent = encodeURIComponent(
      JSON.stringify([
        {
          query: operation.query.loc! && operation.query.loc!.source!.body!,
          endpoint: 'http://localhost:4000/',
          variables: JSON.stringify(operation.variables),
          headers: operation.getContext().headers,
        },
      ])
    );

    console.log(
      '********************************************************************************'
    );
    console.log(
      `QUERY (${
        operation.operationName || 'unnamed'
      }) : ${httpEndpoint}/?tabs=${tabsComponent}`
    );

    console.log(
      '********************************************************************************'
    );

    return forward(operation);
  });

  const options = {
    link: ApolloLink.from([authLink, loggerLink, httpLink]),
    defaultHttpLink: false,
    cache,
  };

  // Create apollo client
  const { apolloClient } = createApolloClient({
    ...defaultOptions,
    ...options,
  });

  // apolloClient.wsClient = wsClient;

  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        // fetchPolicy: 'cache-and-network',
      },
    },
    errorHandler(error) {},
  });
  return apolloProvider;
}
